var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLegalJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "url(#paint0_linear_1350_34817)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 46.5H37.75C44 46.5 46.5 44 46.5 37.75V30.25C46.5 24 44 21.5 37.75 21.5H30.25C24 21.5 21.5 24 21.5 30.25V37.75C21.5 44 24 46.5 30.25 46.5Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 28.6875V37.125C41.5 35.75 40.375 34.625 39 34.625H29C27.625 34.625 26.5 35.75 26.5 37.125V28.6875C26.5 27.3125 27.625 26.1875 29 26.1875H39C40.375 26.1875 41.5 27.3125 41.5 28.6875Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 38.6875H41.5",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 38.6875H25.25",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 36.5V32.75C41.5 31.375 40.375 30.25 39 30.25H29C27.625 30.25 26.5 31.375 26.5 32.75V36.5",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 37.125V38.6875H37.125C37.125 40.4125 35.725 41.8125 34 41.8125C32.275 41.8125 30.875 40.4125 30.875 38.6875H26.5V37.125C26.5 35.75 27.625 34.625 29 34.625H39C40.375 34.625 41.5 35.75 41.5 37.125Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1350_34817",
    x1: 34,
    y1: 0,
    x2: 34,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922994"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalJob);
export default __webpack_public_path__ + "static/media/LegalJob.af34ae6f663f8a0e422da0d06d088151.svg";
export { ForwardRef as ReactComponent };